import './cart-ui.js';
import './callback-ui.js';

;(function() {
	jQuery(document).ready(function($) {

        // Select all links with hashes
        $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                return false;
                } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
                };
            });
            }
        }
        });

        // Accordion
        $('.accordion-item__header').click(function() {
            $(this)
                .toggleClass('is-active')
                .next('.accordion-item__body')
                .slideToggle('250');
        });

        // Hamburger animation
        $('.js-hamburger-toggle').on('click', function() {
            $('.js-hamburger-toggle').toggleClass('is-active');

            $('body, html').toggleClass('js-nav-open');
            return false;
        });

        // Close the mobile menu when a link is tapped
        $('.mobile-nav a').on('click', function() {
            $('.js-hamburger-toggle').removeClass('is-active');
            $('body, html').removeClass('js-nav-open');
        });

        // Mobile menu
        $('.navigation--mobile .menu-item-has-children').append('<div class="menu-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#000" stroke-width="2"/></svg></div>');
        $('.navigation--mobile .menu-arrow').click(function () {
            $(this).parent().toggleClass('is-active');
        });

    });
}());